<xemex-page-header
  [title]="'sidebarMenu.devices' | translate"
></xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="deviceStore.isLoading()"
    [totalCount]="totalCount()"
    [rowLink]="rowLink"
    (pageChange)="onPageChange($event)"
  >
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [initialFilters]="initialFilters()"
      [searchPlaceholder]="'devices.filter.placeholderdeviceLDN' | translate"
      (searchChange)="onSearchChange($event)"
      (filterChange)="onFilterChange($event)"
    >
    </xemex-table-filter-bar>
  </xemex-table>
</xemex-page-body>
